export const common = {
  // Brand
  brandName: 'EachTeach',

  // Language names (LanguageSwitcher)
  languageName: '한국어',
  changeLanguage: '언어 변경',

  // Navbar
  nav: {
    home: '홈',
    courseFlow: '코스 흐름',
    services: '서비스・도구',
    register: '커뮤니티 등록',
    menu: '메뉴',
  },

  // Footer
  footer: {
    mission:
      '개인 언어 가정교사와 전문가가 함께 배우고 교육의 질을 서로 높이는 커뮤니티. "가르치는 것"을 더 자유롭고 더 가깝게.',
    community: '커뮤니티',
    communityRegister: '커뮤니티 등록',
    services: '서비스・도구',
    about: 'About',
    aboutEachTeach: 'EachTeach 소개',
    philosophy: '이념・미션',
    allRightsReserved: 'All rights reserved.',
  },

  // Shared actions / states
  close: '닫기',
  cancel: '취소',
  submit: '전송',
  submitting: '전송 중...',
  loading: '로딩 중...',
  required: '필수',
  optional: '선택',
};
